import { Badge } from "../components/ui/badge";

export default function Kenntnisse() {
  const skills = {
    "Programmierung": ["Python", "Jupyter Notebook","MATLAB", "C/C++", "Verilog", "Java"],
    "KI & Analyse": ["Machine Learning", "Deep Learning", "PCA", "SVM","CNN","Transfer Learning", "Clustering", "Regression", "Supervised, Unsupervised Learning"],
    "SAP": ["End-to-End Business Processes mit SAP S/4HANA (IEE2E)", "Analytics Cloud (SAC)", "SAP BW/4HANA","SAP Fiori","SAP S/4HANA Cloud","Datenmodellierung, Unternehmensplanung und Integration mit SAC", "HANA Studio: BW Modeling, SAP GUI, HANA Modeler, BW Cockpit", "Lumira", "Crystal Reports", "Analysis for Microsoft Excel"],
    "Data Science": ["SQL", "Jupyter Notebook", "NoSQL", "Power BI","Microsoft Excel","Power Query", "Big Data", "Dashboard", "Datenprozesse"],
    "Cisco und Computer Netzwerke": ["Cybersecurity Essentials", "CCNAv7: Introduction to Networks", "DevNet Associate (CCDNA)"],
    "Projektplanung": ["Scrum", "Gantt-Diagramm", "Canvas-Chart","Prototyping","Budgetplan","Kommunikationsplan","Erstellen von Fragebögen","Pivot-Tabelle","Personas","User Interface"],
    "Programme": ["Visual Studio Code", "SAP Fiori", "Cisco Packet Tracer", "MATLAB/Simulink","Blender","Latex","Mikroprozessoren"],
    "EMPro (EMDesign)": ["Magnetresonanztomography (MRT) Simulation", "5G - Antennenkonzepte", "Implantierbare Antennen"],
    "Medizintechnik": ["Kardiovaskuläres System", "Respiratorisches System", "Schlafanalyse", "Elektronik","Sensorik","zentrales Nervensystem (ZNS)","Nephrologie" ],
  };

  return (
    <div className="p-4 space-y-6 max-w-6xl mx-auto bg-marine text-lightgray">
      <h1 className="text-3xl font-bold text-gold">Kenntnisse</h1>

      {/* Tech-Skills */}
      {Object.entries(skills).map(([kategorie, liste]) => (
        <div key={kategorie} className="space-y-1">
          <h2 className="text-lg font-semibold text-silver">{kategorie}</h2>
          <div className="flex flex-wrap gap-1.5">
            {liste.map((skill) => (
              <Badge key={skill}>{skill}</Badge>
            ))}
          </div>
        </div>
      ))}

      {/* Module */}
      <section className="mt-10">
        <h2 className="text-2xl font-semibold text-gold mb-6">🎓 Absolvierte Module</h2>

        <div className="flex flex-col md:flex-row gap-12">
          {/* Bachelor */}
          <div className="flex-1">
            <h3 className="font-semibold text-lg text-silver mb-2">Bachelor – Biomedizintechnik</h3>
            <ul className="list-disc list-inside text-lightgray space-y-1">
              <li>Mathematik I & II</li>
              <li>Einführung in die Programmierung</li>
              <li>Mikroprozessortechnik</li>
              <li>Physik I & II</li>
              <li>Grundlagen der Elektrotechnik</li>
              <li>Signal- und Systemtheorie</li>
              <li>Signalverarbeitung & Regelungstechnik</li>
              <li>Programmierung (Objekte & Anwendungen, Datenstrukturen)</li>
              <li>Sensorik & Messtechnik</li>
              <li>Grundlagen der Medizin I–V</li>
              <li>Biochemie, Physiologie & Anatomie</li>
              <li>Modellbildung & Simulation für die Biomedizintechnik</li>
              <li>Entwicklungsmethodik mit MATLAB / Simulink</li>
              <li>Medizinische Signalverarbeitung</li>
              <li>Systembiologie</li>
              <li>Diagnose/Therapie</li>
              <li>MPG, Normen, HW-/SW-Sicherheit, EMV</li>
              <li>Cybersecurity 1</li>
              <li>Grundlagen der Mensch-Computer-Interaktion</li>
              <li>Projektorientiertes Arbeiten I & II</li>
              <li>Fachpraktika I & II</li>
              <li>BWL & Gesundheitswirtschaft</li>
              <li>Seminar, Präsentationstechnik</li>
            </ul>
          </div>

          {/* Master */}
          <div className="flex-1">
            <h3 className="font-semibold text-lg text-silver mb-2">Master – Informationstechnik</h3>
            <ul className="list-disc list-inside text-lightgray space-y-1">
              <li>Höhere Mathematik</li>
              <li>Theoretische Elektrotechnik 1 & 2</li>
              <li>Kommunikationstechnik 1 & 2</li>
              <li>Digitale Signalverarbeitung 1 & 2</li>
              <li>KI-Systeme 1 & 2</li>
              <li>Embedded System 1</li>
              <li>Computer-Netzwerke 1 & 2</li>
              <li>Biomedical Signal Processing</li>
              <li>Elektronik in der Medizintechnik 1 & 2</li>
              <li>Projektmanagement und Projektplanung</li>
              <li>Projektarbeit 1 & 2</li>
              <li>Data Science und Softwareengineering</li>
              <li>Service-orientierte Anwendungen und Dienste</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
